import React, { createElement } from 'react'
import {
	BrowserRouter,
	Navigate,
	Route,
	Routes as Switch
} from 'react-router-dom'
import { AppWrapper } from '../../shared/components/AppWrapper'

import { routesData } from './data'
import routesEnum from './enum'

function Routes(): JSX.Element {
	return (
		<BrowserRouter>
			<Switch>
				{routesData.map(
					({ component, path, accessTypes, params, ...props }) => (
						<Route
							key={path}
							path={params ? `${path}/:${params}` : path}
							element={
								<AppWrapper>{createElement(component, props)}</AppWrapper>
							}
						/>
					)
				)}

				<Route path='*' element={<Navigate to={routesEnum.HOME} replace />} />
			</Switch>
		</BrowserRouter>
	)
}

export default React.memo(Routes)
